import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OperatingStatus } from './operating-status.interface';

@Injectable({
    providedIn: 'root'
})
export class OperatingStatusService {
    private updateData$ = new BehaviorSubject<OperatingStatus>(null);
    //
    /**
     * Add a local map to store the results and check for them later
     * the primary use being when the list renders new results it will possibly
     * display old data
     */
    private dashMap = new Map<string, OperatingStatus>();

    constructor() { }

    checkForUpdate(facilityId): OperatingStatus {
        return this.dashMap.get(facilityId) || {};
    }

    sendUpdate(statusUpdate: OperatingStatus) {
        // store the new status
        this.dashMap.set(statusUpdate.facilityId, statusUpdate);

        this.updateData$.next(statusUpdate);
    };

    listenForUpdates$(): Observable<any> {
        return this.updateData$.asObservable();
    }
}
